import { Switch } from "@/components/ui/switch";

export interface SwitchProps {
  value?: boolean,
  onValueChange?: (value: boolean, extraOpts?: Record<string, unknown>) => void,
  showLabel?: boolean,
  disabled?: boolean,
  className?: string,
}

export const SwitchComponent = ({ value, onValueChange, disabled, className, showLabel = false, ...restProps }: SwitchProps) => {
  const onChange = (value: boolean) => {
    onValueChange?.(value)
  }

  return (
    <div className="flex">
      <Switch
        checked={value}
        onCheckedChange={onChange}
        disabled={disabled}
        className={className}
        {...restProps}
      />
      {showLabel && <span className="pl-2">{value ? 'Enabled' : 'Disabled'}</span>}
    </div>
  );
}
